export interface ViaColumn {
  id: string;
  name: string;
  deductsOfferQuota: boolean;
}

/**
 * Separate-quota vias are rendered first, followed by the vias that deduct
 * from the offer's initial quota. The relative order inside each group is the
 * catalog's (name-ascending, as returned by the API).
 */
export function orderViaColumns(columns: ViaColumn[]): ViaColumn[] {
  return [
    ...columns.filter((c) => !c.deductsOfferQuota),
    ...columns.filter((c) => c.deductsOfferQuota),
  ];
}

/** True when the tenant has at least one separate-quota via. */
export function hasSeparateQuotaColumn(columns: ViaColumn[]): boolean {
  return columns.some((c) => !c.deductsOfferQuota);
}

/**
 * Splits a row's entered quotas into the part that counts against the offer's
 * declared quota and the part that is additional to it. Cells are aligned to
 * `columns` by index; a cell with no matching column is ignored.
 */
export function splitCellTotals(
  cells: ({ quota: string } | undefined)[],
  columns: ViaColumn[],
): { deducting: number; separate: number } {
  let deducting = 0;
  let separate = 0;
  cells.forEach((cell, index) => {
    const column = columns[index];
    if (!column) {
      return;
    }
    const value = Number(cell?.quota) || 0;
    if (column.deductsOfferQuota) {
      deducting += value;
    } else {
      separate += value;
    }
  });
  return { deducting, separate };
}
